import { MenuBarProps } from "./types";
import styles from "./styles.module.css";
import { DesktopMenu, TopLevelLink } from "./components";

export const MenuBarDesktop = ({
  navigationItems,
  onMenuToggle,
  className,
}: MenuBarProps) => {
  return (
    <nav className={styles.wrapper}>
      {navigationItems.map((item) => {
        return "group" in item ? (
          <DesktopMenu
            key={item.group}
            item={item}
            onMenuToggle={onMenuToggle}
            className={className}
          />
        ) : (
          <TopLevelLink
            key={item.name}
            label={item.name}
            href={item.uri as string}
            className={className}
          />
        );
      })}
    </nav>
  );
};
